let reviewChecklistParams = {
    EmployeeReviewChecklistId: null,
    EmployeeReviewId: null,
    Checked: null,
    ChecklistText: null,
    Phone: null,
    Email: null,
    DocumentLink: null,
    InfoText: null,
    CreatedDateUtc: null,
    CreatedBy: null,
    ModifyDateUtc: null,
    ModifiedBy: null,
    DeletedDateUtc: null,
    DeletedBy: null,
    DisabledDateUtc: null,
    DisabledBy: null,
    Config: null,
}
export default reviewChecklistParams